module.exports = __webpack_public_path__ + "media/images/getting-started-docs-391ad41f4194886ab75b159a8a7b6724.png";